import React from "react";

// const CONTAINER_CLASSES =
// "group relative p-[2px] bg-black-button-border rounded-full transition-all duration-300";

const CONTAINER_CLASSES = `
  group relative p-[2px] rounded-full
  before:content-[''] before:absolute before:inset-0 before:rounded-full 
  before:border-[3px] before:border-transparent before:bg-gradient-to-r 
  before:from-[#FFFFFF] before:to-[#999999] 
  before:bg-[length:400%_400%] before:animate-borderSpin 
  before:z-[-1] overflow-hidden transition-all duration-300 shadow-custom-glow
`;
const BUTTON_CLASSES_BASE =
  "relative flex items-center gap-2 text-white leading-[140%] font-medium bg-black-button-unhover-color rounded-full shadow-lg shadow-gray-700/30 transition duration-300";
const BUTTON_CLASSES_HOVER =
  "hover:bg-black-button-hovered-color hover:shadow-gray-500/50";
const BLUR_EFFECT =
  "absolute inset-0 rounded-full border-[1px] border-gray-400/50 blur-md";

const BlackButton = ({
  text = "Click me",
  onClick,
  className = "",
  padding = "px-5 py-2.5 md:px-6 md:py-4",
  textClassName = "text-sm md:text-lg",
  icon = null,
  disabled = false,
  ariaLabel = "",
}) => {
  // Enable hover only if onClick is provided
  const buttonClasses = onClick
    ? `${BUTTON_CLASSES_BASE} ${BUTTON_CLASSES_HOVER} ${padding}`
    : `${BUTTON_CLASSES_BASE} ${padding} cursor-default`;

  return (
    <div
      className={`${CONTAINER_CLASSES} ${className} ${
        disabled ? "opacity-50" : ""
      }`}
    >
      <button
        onClick={onClick}
        className={buttonClasses}
        disabled={disabled}
        aria-label={ariaLabel || text}
      >
        <span className={textClassName}>{text}</span>
        {icon && <span className="text-lg">{icon}</span>}
        <div className={BLUR_EFFECT} />
      </button>
    </div>
  );
};

export default BlackButton;
